import { Component, ElementRef, Input, Renderer2, ViewEncapsulation, inject } from '@angular/core';

import { NavbarHorizontalStyle1Component } from './horizontal/style-1/style-1.component';
import { NavbarVerticalStyle1Component } from './vertical/style-1/style-1.component';
import { NavbarVerticalStyle2Component } from './vertical/style-2/style-2.component';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
        imports: [NavbarHorizontalStyle1Component, NavbarVerticalStyle1Component, NavbarVerticalStyle2Component]
})
export class NavbarComponent
{
    private _elementRef = inject(ElementRef);
    private _renderer = inject(Renderer2);

    // Private
    _variant: string;



    /**
     * Constructor
     *
     * @param _elementRef
     * @param _renderer
     */
    constructor()
    {
        // Set the private defaults
        this._variant = 'vertical-style-1';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Variant
     */
    get variant(): string
    {
        return this._variant;
    }

    @Input()
    set variant(value: string)
    {
        // Remove the old class name
        this._renderer.removeClass(this._elementRef.nativeElement, this.variant);

        // Store the variant value
        this._variant = value;

        // Add the new class name
        this._renderer.addClass(this._elementRef.nativeElement, value);
    }
}
